import VueTypes from 'vue-types';
import { columnItemStructure } from '@/themes/novaporta/components/widgets/Footer/types'
export default {
    props: {
        item: VueTypes.oneOfType([columnItemStructure]).isRequired
    },
    computed: {
        type() {
            return this.item.type;
        },
        classes() {
            return `--${this.item.classes}` || null;
        },
    },
    methods: {
        pathForImage(item) {
            if (item.local) {
                return require(`@/themes/novaporta/assets/icons/${item.image}`);
            }
            return item.image;
        }
    }
}